import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import Title from "../components/Title"
import Image from "gatsby-image"
import SEO from "../components/SEO"

const About = ({data:{about:{nodes}}}) => {
  const{ info, title, image } = nodes[0]

  return(
    <Layout>
      <SEO title="About Us" description="this is our about-us page" />
      <section className="about-page">
        <div className="section-center about-center">
          <Image fluid= {image.childImageSharp.fluid} className="about-img" />
          <article className="about-text">
            <Title title="about us" />
            <p id="p-about">{info}</p>
          </article>
        </div>
      </section>
    </Layout>

  )
}

export const query = graphql`
  {
    about:allStrapiAbout {
      nodes {
        tittle
        info
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`

export default About
